import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const ErrorsPage = lazy(() => import('./ErrorsPage'));

export const errorRoutes: RouteObject[] = [
  {
    path: 'errors',
    element: (
      <ProtectedRoute action="errors:view">
        <ErrorsPage />
      </ProtectedRoute>
    ),
  },
];
